/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-syntax */
import { MoreOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/client";
import { List, Tag, Tooltip, message, Checkbox, Dropdown } from "antd";
import { capitalize, orderBy, uniqBy } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../../amplify/authenticator-provider";
import {
  UPDATE_LEAD,
  UPDATE_LEAD_OPPORTUNITY,
  UPDATE_OPPORTUNITY_STAGE_NAME,
} from "../../../../graphql/mutation";
import { AccessPermissionAction } from "../../../../library/constants";
import { checkAccessPermission } from "../../../../library/helpers";
import useLang from "../../../../hooks/useLang";
import { crmLinkGeneration } from "./crmLinks";
import OpportunityWarning from "./opportuityWarning";
import { GET_OPPORTUNITY_STATUS } from "../../../../graphql/query";
import { getLeadOpportunitySource } from "../../leadSourceHelper";
import { getLeadOpportunityStatus } from "../../leadStatusHelper";
import "./opportunityLayer.css";
import DownIcon from "../../../../icons/DownIcon";
import { statusColor } from "../engagementHelpers";
import { OpportunityDrawer } from "./opportunityDrawer";
import { changeMessageOpportunity, setShowAll } from "../../../../redux/slices/leadSlice";
import { EditPencilIcon } from "../../../../icons/js/PencilIcon";
import { convertUtcToLocal } from "../../../../library/utils";

const SFOpprStatus = [
  {
    statusTypeId: "1",
    status: "Duplicate",
  },
];

const OpportunityLayer = props => {
  const {
    leadOpportunities,
    leadFullname,
    crmLeadObj,
    selectedLead,
    crmIntegrationType,
    crmIntegrationData,
    refetchLeads,
    leadUsers,
    allowChangeStatus = true,
    refetchLeadDetails,
    setActiveOpp,
    oppValue,
    setVisibleMergeOpportunityModal,
    setRecords,
    setDuplicateRecord,
    setSelectedOpportunityData,
    setSelectedLead,
    getLeadOpportunities,
  } = props;
  const { messageOpportunity } = useSelector(state => state.lead);
  const [lang] = useLang();
  const [statusList, setStatusList] = useState([]);
  const [statusId, setStatusId] = useState(selectedLead?.leadStatusTypeId);
  const [opportunityDrawer, setopportunityDrawer] = useState({
    open: false,
    item: {},
  });
  const [isSFOppr, setIsSfOppr] = useState(false);
  const [isDSOppr, setIsDsOppr] = useState(false);
  const [isOpprOverall, setIsOpprOverall] = useState(false);
  const [list, setlist] = useState([]);
  const [listTemp, setListTemp] = useState([]);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [state, setState] = useState(false);
  const [userLocationsId, setUserLocationsId] = useState([]);
  const [opportunityWarningDialog, setOpportunityWarningDialog] = useState(false);
  const [opportunityInfo, setOpportunityInfo] = useState({});
  const [isOpporDialogFlagChanged, setIsOpprDialogFlagChanged] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(oppValue);
  const { showAll } = useSelector(state => state.lead);

  const dispatch = useDispatch();
  const handleOpporDialogFlagChanged = () => {
    setIsOpprDialogFlagChanged(true);
    localStorage.setItem("isOpporDialogFlagChangedLocal", "true");
  };
  const mostRecentOppr = orderBy(
    selectedLead?.leadOpportunities || [],
    item => new Date(item.updatedDate),
    "desc"
  )[0];

  const { user } = useContext(UserContext);

  const [updateLeadStatus] = useMutation(UPDATE_LEAD);
  const [updateSFStage] = useMutation(UPDATE_OPPORTUNITY_STAGE_NAME);
  const [updateLeadOpportunity, { loading: updateLeadOpportunityLoader }] =
    useMutation(UPDATE_LEAD_OPPORTUNITY);

  useEffect(() => {
    if (showAll?.length === 0 && leadOpportunities?.length > 0) {
      const temp = leadOpportunities?.map((item, i) => true);
      dispatch(setShowAll({ showAll: temp || [] }));
    }
  }, [leadOpportunities]);

  useEffect(() => {
    if (user && user?.locations?.length > 0) {
      const locationIDs = user?.locations.map(location => location?.location?.id);
      setUserLocationsId(locationIDs);
    }
  }, [user]);

  useEffect(() => {
    setStatusId(selectedLead?.leadStatusTypeId);
  }, [selectedLead?.leadStatusTypeId]);

  useEffect(() => {
    setSelectedOpportunity(oppValue);
  }, [oppValue]);

  useEffect(() => {
    if (crmIntegrationType === "SF") {
      if (
        leadOpportunities?.length > 0 &&
        leadOpportunities[0]?.sfLeadOpportunities?.length > 0 &&
        leadOpportunities[0]?.sfLeadOpportunities[0]?.sfOpportunityId
      ) {
        setIsSfOppr(true);
        setIsOpprOverall(true);
      } else {
        setIsSfOppr(false);
        setIsOpprOverall(false);
      }
    }
    if (crmIntegrationType === "DT") {
      setIsOpprOverall(true);
    }
    if (crmIntegrationType === "DS") {
      if (
        leadOpportunities?.length > 0 &&
        leadOpportunities[0]?.dsOpportunityEvents?.length > 0 &&
        leadOpportunities[0]?.dsOpportunityEvents[0]?.dsEventId
      ) {
        setIsDsOppr(true);
        setIsOpprOverall(true);
      } else {
        setIsDsOppr(false);
        setIsOpprOverall(false);
      }
    }
  }, [crmIntegrationType, selectedLead]);

  useEffect(() => {
    if (!isSFOppr) {
      const SFStatusList = [...crmIntegrationData];

      crmIntegrationData?.length > 0 && setlist([...uniqBy(SFStatusList, "status")]);
      setState(prev => !prev);
      crmIntegrationData?.length > 0 && setListTemp([...uniqBy(SFStatusList, "status")]);
    }

    if (crmIntegrationType === "DS") {
      const SFStatusList = [...crmIntegrationData];
      crmIntegrationData?.length > 0 && setlist([...uniqBy(SFStatusList, "status")]);
      setState(prev => !prev);
    }
  }, [crmIntegrationData, isSFOppr, isDSOppr]);

  useEffect(() => {
    if (!isSFOppr && listTemp?.length > 0) {
      const SFStatusList = [...crmIntegrationData];

      const index = list?.length > 0 && list?.findIndex(item => +item?.statusTypeId === +statusId);
      if (index === -1) {
        const obj = SFStatusList?.find(item => +item.statusTypeId === +statusId);
        if (obj) {
          const dummyList = [...list];
          const findIndexStatus = dummyList?.findIndex(item => item.status === obj.status);
          dummyList[findIndexStatus] = obj;
          setlist([...dummyList]);
        }
      } else {
        setlist([...list]);
      }
    }
  }, [listTemp, isSFOppr, isDSOppr, statusId]);

  useEffect(() => {
    if (crmIntegrationType === "SF") {
      if (isSFOppr) {
        const sfStageName =
          selectedLead?.leadOpportunities[0]?.sfLeadOpportunities[0]?.sfOpportunityStage;
        setStatusId("2");
        setStatusList([...SFOpprStatus, { statusTypeId: "2", status: sfStageName }]);
      } else {
        setStatusList([...list]);
      }
    } else {
      setStatusList([...list]);
    }
  }, [isDSOppr, isSFOppr, list, selectedLead?.leadStatusTypeId]);

  const handleOpportunityStatusUpdation = async (oppStatus, opportunity) => {
    // return console.log(oppStatus, opportunity);
    const opporResp = await updateLeadOpportunity({
      variables: {
        leadOpportunityId: opportunity.id,
        opportunityStatusId: oppStatus,
      },
    });
    if (opporResp.data.updateLeadOpportunity.statusCode === 200) {
      message.success(opporResp?.data.updateLeadOpportunity.message);
      refetchLeadDetails();
      setConfirmModalOpen(false);
    } else {
      message.error(opporResp?.data.updateLeadOpportunity.message);
    }
  };

  const convertData = data => {
    return data?.map((item, index) => ({
      id: item?.id, // Incremental id starting from 1
      name: {
        value: item?.name, // Joining the name array values
        selected: false,
      },
      type: {
        value: item?.opportunityType?.name || "N/A",
        selected: false,
      },
      location: {
        value: item?.location?.title || "N/A", // Placeholder if location is not defined
        selected: false,
      },
      vehicle: {
        value:
          item?.vehiclesOfInterest[0]?.make +
            item?.vehiclesOfInterest[0]?.year +
            item?.vehiclesOfInterest[0]?.model || "N/A", // Placeholder if vehicle is not defined
        selected: false,
      },
      owner: {
        value: item?.leadOpportunityUsers[0]?.user?.fullName || "N/A", // Placeholder if owner is not defined
        selected: false,
      },
      source: {
        value: item?.opportunitySource?.name || "N/A",
        selected: false,
      },
      status: {
        value: item?.opportunityStatus?.name || "N/A",
        selected: false,
      },
    }));
  };

  const handleOpportunityName = oppr => {
    let opprName = oppr?.name;
    // DS
    if (
      (oppr?.dsOpportunityEvents?.length > 0 && oppr?.dsOpportunityEvents[0]?.dsEventId) ||
      crmLeadObj?.dsExtractedLead?.dsLeadId
    ) {
      opprName =
        oppr &&
        oppr?.dsOpportunityEvents &&
        oppr?.dsOpportunityEvents.length > 0 &&
        oppr?.dsOpportunityEvents[0]?.dsEventId
          ? `${lang.delearSocketOpprId} - ${oppr?.name}`
          : oppr?.name;
    }
    // SF
    if (
      (oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId) ||
      crmLeadObj?.sfExtractedLead?.sfLeadId
    ) {
      opprName = oppr?.sfLeadOpportunities[0]?.sfOpportunityId
        ? oppr?.name
        : `${lang.lead}: ${leadFullname}`;
    }
    return opprName;
  };

  const GetCrmTypeName = () => {
    const crmTypeName =
      crmIntegrationType === "DS"
        ? lang.dealerSocket
        : crmIntegrationType === "DT"
        ? lang.dealerteam
        : crmIntegrationType === "SF"
        ? lang.salesforce
        : crmIntegrationType === "VIN"
        ? lang.vinSolutions
        : crmIntegrationType === "EL"
        ? lang.ELead
        : crmIntegrationType === "MF"
        ? lang.Momentum
        : crmIntegrationType === "ADF"
        ? lang.ADF
        : lang.smaiCrm;
    return <Tooltip title={crmTypeName}>{crmTypeName}</Tooltip>;
  };

  const handleOpportunityWarningDialog = (item, crmLink, opprId, opprName, isOpp = false) => {
    setOpportunityInfo({
      ...item,
      opprLink: crmLink,
      opprId: opprId,
      opprName: opprName,
      isOpp: isOpp,
    });
    setOpportunityWarningDialog(true);
  };

  const handleStatusChangeSfOppr = async (oppStatus, opportunityItem) => {
    const leadStage = selectedLead?.leadOpportunities[0];
    const stageRes = await updateSFStage({
      variables: {
        leadOpportunityId: opportunityItem?.id,
        stageName: "Duplicate",
      },
    });
    if (stageRes?.data?.updateSfLeadStage?.statusCode !== 200) {
      message.error(stageRes?.data?.updateSfLeadStage?.message);
    } else {
      message.success(stageRes?.data?.updateSfLeadStage?.message);
      refetchLeads();
    }
  };

  const getAPIHandler = (oppStatus, opportunityItem) => {
    if (crmIntegrationType === "DS") {
      return handleOpportunityStatusUpdation(oppStatus, opportunityItem);
    }

    if (crmIntegrationType === "SF") {
      if (isSFOppr) {
        return handleStatusChangeSfOppr(oppStatus, opportunityItem);
      }
      return handleOpportunityStatusUpdation(oppStatus, opportunityItem);
    }
  };

  const renderLabel = () => {
    if (crmIntegrationType === "SF") {
      if (isSFOppr) {
        return lang.changeStage;
      }
    }
    return lang.changeStatus;
  };

  // TODO: Add location from the opportunity Object of the lead
  const handleOwnerName = (opprUsers, crmIntegrationType = "") => {
    return (
      <div className="flex flex-wrap gap-1 text-sm text-grey-700 font-[400]">
        {(opprUsers || []).map((item, i) => (
          <p key={`owner0key-${i}`}>
            {`${item?.user?.fullName} ${
              item?.user?.companyRole?.name
                ? `(${item?.user?.companyRole?.name || ""} - ${item?.userType?.name || ""})`
                : ""
            }`}
          </p>
        ))}
      </div>
    );
  };

  const [opportunityStatusList, setOpportunityStatusList] = useState([]);

  const { loading: opportunityStatusLoader } = useQuery(GET_OPPORTUNITY_STATUS, {
    variables: {
      // opportunityTypeId: 1,
      locationIds: sessionStorage?.getItem("currentLocationId")?.split(","),
      fetchAll: true,
    },
    onCompleted: resp => {
      setOpportunityStatusList(resp.getOpportunityStatus);
    },
  });

  const removeMergedOpportunity = (ids, opportunities) => {
    const updatedOpportunities = opportunities?.filter(lead => !ids.includes(+lead.id));
    setSelectedLead({ ...selectedLead, leadOpportunities: updatedOpportunities });
  };

  const getMergedOpportunity = async (item, ids, opportunities) => {
    const duplicateOpportunities = await getLeadOpportunities({
      variables: {
        leadOpportunityIds: ids,
      },
    });

    const temp = [...(duplicateOpportunities.data?.getLeadOpportunitiesById || [])];

    const index = opportunities.findIndex(opportunity => opportunity.id === item.id);

    if (index === -1) {
      return;
    }

    // Create a new array with the temp array added after the matching lead
    const updatedOpportunities = [
      ...opportunities.slice(0, index + 1), // All leads up to the matching lead (inclusive)
      ...temp, // Add the temp array after the matching lead
      ...opportunities.slice(index + 1), // The rest of the leads
    ];

    setSelectedLead({ ...selectedLead, leadOpportunities: updatedOpportunities });
  };

  const handleOpportunityOptions = (key, item) => {
    switch (key) {
      case "edit":
        setopportunityDrawer({ open: true, item });
        break;
      case "viewInChat":
        dispatch(changeMessageOpportunity(item.id));
        break;
      default:
        break;
    }
  };

  const canMergeOppor = checkAccessPermission(AccessPermissionAction.MERGE_LEADS_OPPS);

  return (
    <div>
      <List
        itemLayout="vertical"
        className="py-1 px-0"
        // dataSource={orderBy(leadOpportunities, item => new Date(item.updatedDate), "desc")}
        dataSource={leadOpportunities}
        pagination={
          leadOpportunities?.length <= 7
            ? false
            : {
                onChange: page => {},
                pageSize: 7,
                size: "small",
              }
        }
        renderItem={(item, i) => {
          const salesForceType =
            crmIntegrationType === "SF"
              ? "usAutoSales"
              : crmIntegrationType === "DT"
              ? "dealerTeam"
              : "";
          let isOpportunity = false;
          if (
            crmIntegrationType === "DS" &&
            item?.dsOpportunityEvents?.length > 0 &&
            item?.dsOpportunityEvents[0].dsEventId
          ) {
            isOpportunity = true;
          } else if (
            crmIntegrationType === "DT" &&
            item?.dtLeadOpportunities?.length > 0 &&
            item?.dtLeadOpportunities[0].dtOpportunityId
          ) {
            isOpportunity = true;
          } else if (
            crmIntegrationType === "SF" &&
            item?.sfLeadOpportunities?.length > 0 &&
            item?.sfLeadOpportunities[0].sfOpportunityId
          ) {
            isOpportunity = true;
          } else if (item?.id) {
            isOpportunity = true;
          }

          const activeLeadOppr = selectedLead?.crmLeadObj;
          const leadId =
            crmIntegrationType === "DS"
              ? activeLeadOppr?.dsExtractedLead?.dsLeadId
              : crmIntegrationType === "DT"
              ? activeLeadOppr?.dtExtractedLead?.dtLeadId
              : crmIntegrationType === "SF"
              ? activeLeadOppr?.sfExtractedLead?.sfLeadId
              : crmIntegrationType === "MF"
              ? activeLeadOppr?.mfExtractedLead?.mfProspectId ||
                activeLeadOppr?.mfExtractedLead?.mfCustomerId
              : null;
          const opprId =
            crmIntegrationType === "DS" && item?.dsOpportunityEvents?.length > 0
              ? item?.dsOpportunityEvents[0].dsEventId
              : crmIntegrationType === "DT" && item?.dtLeadOpportunities?.length > 0
              ? item?.dtLeadOpportunities[0].dtOpportunityId
              : crmIntegrationType === "SF" && item?.sfLeadOpportunities?.length > 0
              ? item?.sfLeadOpportunities[0].sfOpportunityId
              : crmIntegrationType === "VIN" && item?.vsLeadOpportunities?.length > 0
              ? item?.vsLeadOpportunities[0].vsLeadId
              : crmIntegrationType === "EL" && item?.elLeadOpportunities?.length > 0
              ? item?.elLeadOpportunities[0].elOpportunityId
              : crmIntegrationType === "MF" && item?.mfLeadOpportunities?.length > 0
              ? item?.mfLeadOpportunities[0].mfLeadId
              : item?.id;

          const linkOpprId =
            crmIntegrationType === "VIN" && item?.vsLeadOpportunities?.length > 0
              ? item?.vsLeadOpportunities[0].vsContactId
              : crmIntegrationType === "EL"
              ? selectedLead?.fullName || ""
              : opprId;
          const crmLeadOpportunityLink = crmLinkGeneration(
            crmIntegrationType,
            isOpportunity,
            linkOpprId,
            leadId,
            salesForceType,
            user?.company?.id
          );

          const leadSourceName = getLeadOpportunitySource(item?.opportunitySource || {});

          const opportunityStatus = getLeadOpportunityStatus(item);
          return (
            <div
              className="mb-1"
              // style={{
              //   backgroundColor: !item?.isActive ? "#FCA5A5" : "",
              // }}
            >
              <div
                style={{
                  backgroundColor: selectedOpportunity === item.id ? "#eff6ff" : "",
                }}
                className={`p-3 w-full flex flex-col items-start justify-start gap-3 border border-solid ${
                  +messageOpportunity === +item.id ? "border-brand-500" : "border-grey-200"
                } rounded-[4px] bg-grey-50  ${
                  item?.isActive === null || item?.isActive === true ? "bg-white" : "bg-white"
                }`}
              >
                <div className="flex-col-centered gap-1 max-w-full">
                  <div className="flex-row-centered gap-0.5 ellipsis w-full max-w-full">
                    <span className="text-sm font-[600] text-grey-700">
                      <GetCrmTypeName />
                    </span>
                    <div
                      onClick={e => e.stopPropagation()}
                      className="idColor flex flex-row items-center text-align-start"
                    >
                      {crmLeadOpportunityLink ? (
                        <a
                          className="labelColor"
                          target="_blank"
                          rel="noreferrer"
                          href={crmLeadOpportunityLink}
                        >
                          <Tooltip title={opprId}>
                            <span className="line-clamp-1">{opprId}</span>
                          </Tooltip>
                        </a>
                      ) : (
                        isOpportunity && (
                          <p className="labelColor font-semibold">
                            #{crmIntegrationType === "MF" ? "" : `SMAI`}
                            {String(opprId).padStart(4, "0")}
                          </p>
                        )
                      )}
                    </div>
                    <Tooltip title={handleOpportunityName(item)}>
                      <div className="flex-row-centered gap-1 w-full">
                        <div className="p-0.5 rounded-full bg-grey-500 " />
                        {handleOpportunityName(item)}
                      </div>
                    </Tooltip>
                  </div>
                  <div>
                    <span className="text-xs font-[400] text-grey-500">
                      {item?.lead?.location?.title || "N/A"}
                    </span>
                    <span className="text-xs font-[400] text-grey-500">
                      {" "}
                      -{" "}
                      <Tooltip
                        title={
                          <div className="flex-col-centered gap-1">
                            <span>
                              Created on:{" "}
                              {convertUtcToLocal(item.createdDate, "MMM DD, YYYY, hh:mm A")}
                            </span>
                            <span>
                              Updated on:{" "}
                              {convertUtcToLocal(item.updatedDate, "MMM DD, YYYY, hh:mm A")}
                            </span>
                          </div>
                        }
                      >
                        {convertUtcToLocal(item.updatedDate, "MMM DD, hh:mm A")}
                      </Tooltip>
                    </span>
                  </div>
                </div>
                <div className="flex-col-centered gap-4">
                  <div className="flex-col-centered items-start gap-1">
                    <span className="text-xs font-[600] text-grey-700">Source:</span>
                    <span>{leadSourceName}</span>
                  </div>
                  <div className="flex-col-centered items-start gap-1">
                    <span className="text-xs font-[600] text-grey-700">Vehicles:</span>
                    <VehicleJSX item={item} />
                  </div>
                  <div className="flex-col-centered items-start gap-1">
                    <span className="text-xs font-[600] text-grey-700">Owners:</span>
                    <span>{handleOwnerName(item?.leadOpportunityUsers, crmIntegrationType)}</span>
                  </div>
                </div>
                <div className="flex-row-centered w-full justify-between">
                  {allowChangeStatus &&
                  (crmIntegrationType === "SF" ||
                    crmIntegrationType === "DT" ||
                    crmIntegrationType === "DS") ? (
                    <div className="flex-row-centered gap-1">
                      <span className="text-xs font-[600] text-grey-700">Status:</span>
                      <Dropdown
                        trigger="click"
                        menu={{
                          items: opportunityStatusList.map((opportunity, index) => ({
                            label: (
                              <span
                                key={index}
                                onClick={() => {
                                  getAPIHandler(opportunity.id, item);
                                }}
                              >
                                {opportunity.name}
                              </span>
                            ),
                          })),
                        }}
                        overlayClassName="max-h-[300px] overflow-y-auto custom-dropdown"
                      >
                        <span
                          className={`flex-row-centered cursor-pointer ${statusColor(
                            opportunityStatus
                          )} text-xs font-[400] gap-1`}
                        >
                          {opportunityStatus} <DownIcon />
                        </span>
                      </Dropdown>
                    </div>
                  ) : (
                    <div className="flex-row-centered gap-1">
                      <span className="text-xs font-[600] text-grey-700">Status:</span>
                      <span
                        className={`flex-row-centered text-xs font-[400] cursor-pointer gap-1 ${statusColor(
                          opportunityStatus
                        )}`}
                      >
                        {opportunityStatus}
                      </span>
                    </div>
                  )}
                  <div className="flex-row-centered gap-2">
                    <Tooltip title="Edit Opportunity">
                      <EditPencilIcon
                        color="#64748B"
                        className="cursor-pointer"
                        onClick={() => setopportunityDrawer({ open: true, item })}
                      />
                    </Tooltip>
                    <Checkbox
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeMessageOpportunity(item.id));
                        } else {
                          dispatch(changeMessageOpportunity("#DEFAULTOPPID"));
                        }
                      }}
                      checked={+messageOpportunity === +item.id}
                    />
                  </div>
                </div>
              </div>
              {item?.potentialOpportunity?.length > 0 && (
                <div className="bg-[#E2E8F0] flex justify-center items-center">
                  <span className="text-[#EF4444]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={13}
                      height={12}
                      fill="none"
                      className="mr-2"
                    >
                      <path
                        fill="#EF4444"
                        d="M12.5 4.5a.5.5 0 0 1-.336.473L1 8.856V11.5a.5.5 0 1 1-1 0V.5A.5.5 0 0 1 .664.028l11.5 4a.5.5 0 0 1 .336.472Z"
                      />
                    </svg>
                    Duplicate opportunity found.
                  </span>
                  {canMergeOppor && (
                    <span
                      className="text-[#3B82F6] ml-1 cursor-pointer"
                      onClick={async () => {
                        setSelectedOpportunityData(item);
                        await getLeadOpportunities({
                          variables: {
                            leadOpportunityIds: item?.potentialOpportunity,
                          },
                          onCompleted: res => {
                            const newData = [...(res?.getLeadOpportunitiesById || [])];
                            newData.unshift(item);
                            setRecords(convertData(newData));
                            setDuplicateRecord(newData);
                            setVisibleMergeOpportunityModal(true);
                          },
                        });
                      }}
                    >
                      Merge It
                    </span>
                  )}
                </div>
              )}
              {item?.opportunityMergeHistory?.length > 0 && (
                <div className="bg-[#334155] flex justify-center items-center">
                  <span className="text-[#FFFFFF]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={13}
                      height={12}
                      fill="none"
                      className="mr-2"
                    >
                      <path
                        fill="#fff"
                        d="M12.5 4.5a.5.5 0 0 1-.336.473L1 8.856V11.5a.5.5 0 1 1-1 0V.5A.5.5 0 0 1 .664.028l11.5 4a.5.5 0 0 1 .336.472Z"
                      />
                    </svg>
                    This is merged opportunity.
                  </span>
                  <span
                    className="text-[#3B82F6] ml-1 cursor-pointer"
                    onClick={() => {
                      if (showAll[i])
                        getMergedOpportunity(
                          item,
                          item?.opportunityMergeHistory,
                          leadOpportunities
                        );
                      else
                        removeMergedOpportunity(item?.opportunityMergeHistory, leadOpportunities);

                      const updatedArray = showAll?.map((val, index) => (index === i ? !val : val));
                      dispatch(setShowAll({ showAll: updatedArray }));
                    }}
                  >
                    {showAll[i] ? "Show All" : "Close"}
                  </span>
                </div>
              )}
            </div>
          );
        }}
      />
      <OpportunityDrawer
        opportunityDrawer={opportunityDrawer}
        setopportunityDrawer={setopportunityDrawer}
        refetch={refetchLeadDetails}
        crmIntegrationType={crmIntegrationType}
        mode="EDIT"
        showCancel
        titleContent={
          <div className="flex flex-col">
            <span className="text-lg font-[600]">
              Modify Opportunity {opportunityDrawer?.item?.name || ""} for{" "}
              {selectedLead?.fullName || ""}
            </span>
            <span className="text-sm font-[400]">
              Provide the following details to modify the opportunity
            </span>
          </div>
        }
      />
      {opportunityWarningDialog && (
        <OpportunityWarning
          opportunityInfo={opportunityInfo}
          crmIntegrationType={crmIntegrationType}
          crmLeadObj={crmLeadObj}
          visibleModal={opportunityWarningDialog}
          handleOKBtn={() => setOpportunityWarningDialog(false)}
          setModalVisible={() => setOpportunityWarningDialog(false)}
          handleOpporDialogFlagChanged={handleOpporDialogFlagChanged}
        />
      )}
    </div>
  );
};
export default OpportunityLayer;

// function to get lead owner info , like redering on lead center for owners (Implementation is in progress)
export const handleOwnerData = (leadUsers, crmIntegration, isOpprOverall = false) => {
  let primaryOwnerName = "Select Owner";

  const ownerArray = leadUsers.map(user => {
    if (user?.userType?.name) {
      return {
        label: `${user?.userType?.name}`,
        username: `${user?.user?.firstName} ${user?.user?.lastName} ${
          user?.user?.companyRole?.name ? `(${user?.user?.companyRole?.name})` : ""
        }`,
        id: user?.userType?.id,
      };
    }

    return {
      label: "",
      username: `${user?.user?.firstName} ${user?.user?.lastName} ${
        user?.user?.companyRole?.name ? `(${user?.user?.companyRole?.name})` : ""
      }`,
      id: "",
    };
  });
  if (crmIntegration === "SF") {
    let ownerArraySF = [];

    if (isOpprOverall) {
      ownerArraySF = ["opportunity owner", "salesperson 1", "salesperson 2"];
    } else {
      ownerArraySF = ["lead owner", "salesperson 1", "bdc rep"];
    }

    let isFoundSF = false;
    for (const ownerLabel of ownerArraySF) {
      for (const owner of ownerArray) {
        if (owner?.label?.toLowerCase() === ownerLabel) {
          primaryOwnerName = owner?.username;
          isFoundSF = true;
          break;
        } else {
          primaryOwnerName = owner?.username;
        }
      }
      if (isFoundSF) break;
    }
  } else if (crmIntegration === "DS") {
    const ownerArray1 = ["primary assigned", "bdc", "secondary assigned"];
    let isFound = false;
    for (const ownerLabel of ownerArray1) {
      for (const owner of ownerArray) {
        if (owner?.label?.toLowerCase() === ownerLabel) {
          primaryOwnerName = owner?.username;
          isFound = true;
          break;
        } else {
          primaryOwnerName = owner?.username;
        }
      }
      if (isFound) break;
    }
  }

  return primaryOwnerName;
};

function VehicleJSX({ item }) {
  const vehicleOfInterest = uniqBy(item?.vehiclesOfInterest || [], v =>
    [v.year, v.make, v.model].join()
  );

  return (
    <div className="flex flex-col items-start justify-start gap-1">
      {vehicleOfInterest?.length > 0 ? (
        vehicleOfInterest?.map((voi, index) => {
          const parseVehicles = () => {
            let name = "";
            if (
              voi?.year !== 0 &&
              voi?.year !== null &&
              voi?.year !== undefined &&
              voi?.year !== "0"
            ) {
              name = `${name} ${voi.year}`;
            }

            if (
              voi?.make !== null &&
              voi?.make !== undefined &&
              voi.make !== 0 &&
              voi.make !== "0"
            ) {
              name = `${name} ${voi.make}`;
            }

            if (
              voi?.model !== null &&
              voi?.model !== undefined &&
              voi?.model !== 0 &&
              voi?.model !== "0"
            ) {
              name = `${name} ${voi.model}`;
            }

            name = name !== "" ? name : "N/A";
            const customerInterest = capitalize(voi?.customerInterest || "");
            const voiName = customerInterest !== "" ? `${name} (${customerInterest})` : name;
            if (voiName.trim() !== "") {
              return (
                <Tooltip placement="topLeft" title={voiName}>
                  <Tag
                    color={
                      voi?.customerInterest === "TRADE"
                        ? "orange"
                        : voi?.customerInterest === "SELL"
                        ? "magenta"
                        : voi?.customerInterest === "BUY"
                        ? "blue"
                        : "magenta"
                    }
                  >
                    {voiName}
                  </Tag>
                </Tooltip>
              );
            } else {
              return <span className="pl-[5px]">No Vehicles</span>;
            }
          };
          return (
            <div className="test-start" key={index}>
              {parseVehicles()}
            </div>
          );
        })
      ) : (
        <span>No Vehicles</span>
      )}
    </div>
  );
}
